import { createSvgIcon } from '@automata/mui-theme';
import CropSquareIcon from '@mui/icons-material/CropSquare';
export const conditionalFlowIcon = createSvgIcon(
  <CropSquareIcon />,
  'conditionalFlowIcon'
);
